export class Token {
    authuuid!: string;
    session!: string;
    token!: string;
    tokenExpiration!: Date;
}